import { render, staticRenderFns } from "./WorkBookCandidates.vue?vue&type=template&id=098cf768&scoped=true&"
import script from "./WorkBookCandidates.vue?vue&type=script&lang=js&"
export * from "./WorkBookCandidates.vue?vue&type=script&lang=js&"
import style0 from "./WorkBookCandidates.vue?vue&type=style&index=0&id=098cf768&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "098cf768",
  null
  
)

export default component.exports